import React, {FC} from "react";
import Container from "@material-ui/core/Container";
import {
    Box,
    Card,
    Grid,
    useMediaQuery,
    useTheme
} from "@material-ui/core";
import Navigation from "../../../Components/Navigation";
import {PetGeneralInfo} from "../../../Components";

interface Props {
	isOnBoarding: boolean,
	setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>>,
}

const GeneralInfo: FC<Props> = ({isOnBoarding, setIsOnBoarding}: Props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    return (
        <Container maxWidth="md">
            <Box marginTop="115px" marginBottom="75px">
                <Grid container>
                    {!isMobile &&
						<Grid item md={3} xs={12}>
						    <Navigation /> 
						</Grid>
                    }
                    <Grid item md={9} xs={12}>
                        <Card
                            variant="outlined"
                            style={{padding: 25}}
                        >
                            <PetGeneralInfo isOnBoarding={isOnBoarding} setIsOnBoarding={setIsOnBoarding} disabled={false} id={{petId:"0"}}/>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default GeneralInfo;
